/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsSpecification: {
  name: 'specification';
  data: string;
} = {
  name: 'specification',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 .5A1.5 1.5 0 0 0 2.5 2v12A1.5 1.5 0 0 0 4 15.5h8a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 12 .5H4Zm6.5 1H4a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h6.5v-13Zm1 13v-13h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-.5ZM6 3.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H6ZM5.5 7a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Z" fill="currentColor"/></svg>`,
};
